import MyPageSelector from './MyPageSelector';
export default MyPageSelector;
